import { ODataSelect } from "@iconics/core";

export class User extends ODataSelect
{
    public Id = '';
    public DisplayName = '';
    public PreferredName = '';
    public UserType = '';
    public Email = '';
}
